import { useTranslation } from 'react-i18next'

import { z } from '@/lib/zod'

export function EditNewsHighlightedImageSchema() {
  const { t } = useTranslation()

  return z.object({
    postImage: z
      .instanceof(File, { message: t('zod:errors.invalid_type') })
      .or(z.array(z.string()))
      .or(z.string()),
  })
}

export type EditNewsHighlightedImageForm = z.infer<
  ReturnType<typeof EditNewsHighlightedImageSchema>
>
